import React from "react";
import PropTypes from "prop-types";
import { FormattedNumber } from "react-intl";

const Money = ({ value }) => {
  return (
    <FormattedNumber
      value={value.amount}
      // eslint-disable-next-line react/style-prop-object
      style="currency"
      currency={value.currency}
    />
  );
};

const currenciesAllowedList = ["EUR", "USD", "GBP"];

Money.propTypes = {
  value: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currency: PropTypes.oneOf(currenciesAllowedList).isRequired,
  }),
};

export { currenciesAllowedList };
export default Money;
